"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const firestore_1 = require("@react-query-firebase/firestore");
const firestore_2 = require("firebase/firestore");
const keyFactory_1 = require("../../Firestore-Query/keyFactory");
/**
 *
 * @param querySnapshot patient snapshot from firebase
 * @returns Los dependants
 */
const selectDependant = (querySnapshot) => {
    const result = [];
    querySnapshot.forEach((document) => {
        if (document.data()?.fullname === undefined) {
            console.error("Hay un dependant roto");
        }
        else {
            result.push({ ...document.data(), uid: document.id });
        }
    });
    return result;
};
/**
 * Obtiene los dependants de la vieja ruta user/$uid
 * @deprecated utilizar usePatient que obtiene el paciente, ya sea dependant o no, de la ruta correcta.
 */
function useDependants(firestore, uid, options, useQueryOptions) {
    const dependantsRef = (0, firestore_2.collection)(firestore, `user/${uid}`, "dependants");
    return (0, firestore_1.useFirestoreQuery)(keyFactory_1.FirestoreKeys.User({
        name: "dependants",
        path: `user/${uid}`
    }, [uid]), dependantsRef, options, {
        ...useQueryOptions,
        select: selectDependant
    });
}
exports.default = useDependants;
